"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIComponent = require("../UIComponent.js"),
    template = require("./Stage.html");
var Stage = function (_UIComponent) {
  _inherits(Stage, _UIComponent);

  function Stage() {
    _classCallCheck(this, Stage);

    return _possibleConstructorReturn(this, (Stage.__proto__ || Object.getPrototypeOf(Stage)).call(this, template));
  }

  _createClass(Stage, [{
    key: "onComponentRendering",
    value: function onComponentRendering(e) {
      return e < 1 && (e = 1), e;
    }
  }]);

  return Stage;
}(UIComponent);

module.exports = Stage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0YWdlLmpzIl0sIm5hbWVzIjpbIlVJQ29tcG9uZW50IiwicmVxdWlyZSIsInRlbXBsYXRlIiwiU3RhZ2UiLCJbb2JqZWN0IE9iamVjdF0iLCJkYXRhIiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBLElBQU1BLGNBQWNDLFFBQVEsbUJBQVJBLENBQXBCO0FBQUEsSUFDSUMsV0FBV0QsUUFBUSxjQUFSQSxDQURmO0lBR01FLEs7OztBQUNGQyxtQkFBQUE7QUFBQUE7O0FBQUFBLHlHQUNVRixRQURWRTtBQUlBQTs7Ozt5Q0FBcUJDLEMsRUFBQUE7QUFJakIsYUFIR0EsSUFBTyxDQUFQQSxLQUNDQSxJQUFPLENBRFJBLEdBR0lBLENBQVA7QUFBT0E7Ozs7RUFUS0wsVzs7QUFhcEJNLE9BQU9DLE9BQVBELEdBQWlCSCxLQUFqQkcifQ==